<template>
    <div>
        <header-theme :breadcrumb="this.breads"></header-theme>
        <main>
            <div class="row">
            <div class="col s6">
                <div style="padding: 35px;" align="center" class="card">
                <div class="row">
                    <div class="left card-title">
                    <b>Circular de Ofertas</b>
                    </div>
                </div>

                <div class="row">
                    <router-link to="/nova-circular">
                        <div style="padding: 30px;" class="grey lighten-3 col s5 waves-effect">
                            <i class="teal-text text-lighten-1 large material-icons">add</i>
                            <span class="teal-text text-lighten-1"><h5>Nova</h5></span>
                        </div>
                    </router-link>
                    <div class="col s1">&nbsp;</div>
                    <div class="col s1">&nbsp;</div>

                    <router-link to="/gerar">
                        <div style="padding: 30px;" class="grey lighten-3 col s5 waves-effect">
                            <i class="teal-text text-lighten-1 large material-icons">print</i>
                            <span class="teal-text text-lighten-1"><h5>Gerar</h5></span>
                        </div>
                    </router-link>
                </div>
                </div>
            </div>

            <div class="col s6">
                <div style="padding: 35px;" align="center" class="card">
                <div class="row">
                    <div class="left card-title">
                    <b>Relatórios</b>
                    </div>
                </div>
                <div class="row">
                    <a href="#!">
                    <div style="padding: 30px;" class="grey lighten-3 col s5 waves-effect">
                        <i class="teal-text text-lighten-1 large material-icons">store</i>
                        <span class="teal-text text-lighten-1"><h5>Produtos</h5></span>
                    </div>
                    </a>

                    <div class="col s1">&nbsp;</div>
                    <div class="col s1">&nbsp;</div>

                    <a href="#!">
                    <div style="padding: 30px;" class="grey lighten-3 col s5 waves-effect">
                        <i class="teal-text text-lighten-1 large material-icons">assignment</i>
                        <span class="teal-text text-lighten-1"><h5>Templates</h5></span>
                    </div>
                    </a>
                </div>
                </div>
            </div>
            </div>

            <div class="row">
            <div class="col s6">
                <div style="padding: 35px;" align="center" class="card">
                <div class="row">
                    <div class="left card-title">
                    <b>Usuário</b>
                    </div>
                </div>

                <div class="row">
                    <a href="#!">
                    <div style="padding: 30px;" class="grey lighten-3 col s5 waves-effect">
                        <i class="teal-text text-lighten-1 large material-icons">assignment</i>
                        <span class="teal-text text-lighten-1"><h5>Editar dados</h5></span>
                    </div>
                    </a>

                    <div class="col s1">&nbsp;</div>
                    <div class="col s1">&nbsp;</div>

                    <a href="#!">
                    <div style="padding: 30px;" class="grey lighten-3 col s5 waves-effect">
                        <i class="teal-text text-lighten-1 large material-icons">vpn_key</i>
                        <span class="teal-text text-lighten-1"><h5>Trocar senha</h5></span>
                    </div>
                    </a>
                </div>
                </div>
            </div>

            <div class="col s6">
                <div style="padding: 35px;" align="center" class="card">
                <div class="row">
                    <div class="left card-title">
                    <b>Sistema</b>
                    </div>
                </div>
                <div class="row">
                    <router-link to="/logout">
                        <div style="padding: 30px;" class="grey lighten-3 col s5 waves-effect">
                            <i class="teal-text text-lighten-1 large material-icons">exit_to_app</i>
                            <span class="teal-text text-lighten-1"><h5>Sair</h5></span>
                        </div>
                    </router-link>
                    <div class="col s1">&nbsp;</div>
                    <div class="col s1">&nbsp;</div>

                    <!-- <a href="#!">
                    <div style="padding: 30px;" class="grey lighten-3 col s5 waves-effect">
                        <i class="teal-text text-lighten-1 large material-icons">view_list</i>
                        <span class="truncate teal-text text-lighten-1"><h5>Sub Category</h5></span>
                    </div>
                    </a> -->
                </div>
                </div>
            </div>
            </div>

            
        </main>
        <side-menu></side-menu>
    </div>
</template>

<script>
import SideMenu from '../shared/side_menu/SideMenu.vue';
import HeaderTheme from '../shared/header_theme/HeaderTheme.vue';

export default {
    name: 'home',
    components: {
        'side-menu': SideMenu,
        'header-theme': HeaderTheme,
    },
    mounted() {
        $(document).ready(function(){
            $('.collapsible').collapsible();
        });
    },
    data () {
        return {
            breads: [
                {
                    url: "#",
                    title: "Home"
                }
            ],
        }
    }   
}
</script>

<style lang="scss" scoped>
main {
  padding-left: 300px;
}
</style>






// WEBPACK FOOTER //
// src/components/home/Home.vue